import React from "react";

/**
 * Pill tab strip shared by the learner pages (same look as the dashboard).
 *
 *   <TabStrip tabs={[{id:"all",label:"All",count:3}]} active={tab} onChange={setTab} />
 */
const TabStrip = ({tabs, active, onChange, className = ""}) => (
  <div
    className={`flex gap-2 overflow-x-auto border-b border-slate-100 p-3 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}
  >
    {tabs.map((tab) => {
      const isActive = active === tab.id;
      return (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab.id)}
          className={`flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
            isActive ? "bg-blue-600 text-white shadow-sm" : "bg-slate-100 text-slate-700 hover:bg-slate-200"
          }`}
        >
          {tab.label}
          {tab.count != null ? (
            <span
              className={`rounded-full px-1.5 py-0.5 text-[11px] font-semibold ${
                isActive ? "bg-white/25 text-white" : "bg-white text-slate-500"
              }`}
            >
              {tab.count}
            </span>
          ) : null}
        </button>
      );
    })}
  </div>
);

export default TabStrip;
